import { ApiRetailerPaymentType } from '@vend/types'
import { useCallback } from 'react'
import { vn } from 'vend-number'
import { useRegisterManager } from '../../../../ng-compat/hooks'
import { SwiperPaymentOption } from '../PaymentModal/types'

export const useHandleSwiperPayment = (amountTendered: string) => {
  const registerManager = useRegisterManager()

  const handleSwiperPayment = useCallback(
    (paymentType: ApiRetailerPaymentType): SwiperPaymentOption | undefined => {
      if (!amountTendered || isNaN(Number(amountTendered))) {
        return
      }
      return {
        amount: vn(amountTendered).toNumber(),
        paymentType,
        paymentModalType: 'swiper',
        currency: registerManager.getActiveOutlet().currency,
        registerId: registerManager.getActiveRegister().id,
      }
    },
    [registerManager, amountTendered]
  )
  return {
    handleSwiperPayment,
  }
}
